module.exports = __webpack_public_path__ + "img/box64.76b09cc5.png";